(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$stateParams', 'PaginationUtil', '$translate', 'pagingParams'];

    function HomeController ($scope, Principal, LoginService, $state, $stateParams, PaginationUtil, $translate, pagingParams) {
        $translate.refresh();

        var vm = this;

        vm.pagingParams = pagingParams;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;

        vm.register = register;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();
